// angular imports
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

// cc-common imports
import { CCLocalStorageCategory, CCLocalStorageService } from 'cc-common';

// devextreme imports
import { DxPopupComponent } from 'devextreme-angular';

// model imports
import { APBillParameterDto } from '../../../cirabooks/shared-cirabooks-module/_models/accounts-payable/ap-bill/ap-bill-parameter-dto';
import { WorkflowDetailsResultDto } from '../../_models/workflow-details-result-dto';

// constants imports
import { Constants } from '../../../_constants/constants';
import { StorageKeyConstants } from '../../../_constants/storage-key-constants';

@Component({
    selector: 'app-workflow-viewer',
    templateUrl: './workflow-viewer.component.html',
    styleUrls: ['./workflow-viewer.component.scss']
})
export class WorkflowViewerComponent implements OnInit {
    @ViewChild('viewerpopup', { static: false }) viewerPopup: DxPopupComponent;

    @Input() apBillDetailParam: APBillParameterDto;
    @Input() workflowId: number;
    @Input() communityId: number;
    @Input() viewOnly: boolean;

    @Output() onClose = new EventEmitter<boolean>();

    popupTitle: string;

    visible = false;
    forceRefresh = false;

    pdfViewerToLeft = false;
    pdfOrder = 2;
    invoiceOrder = 1;
    separateWindow = false;
    pdfURL: string = null;
    pdfLoader: boolean;

    formPanelWidth: string;
    pdfViewerWidth: string;

    constructor(private readonly localStorageService: CCLocalStorageService) {}

    ngOnInit() {
        this.show();
        this.popupTitle = `Workflow #${this.workflowId} (Read Only)`;
    }

    show(): void {
        this.visible = true;
    }

    onShown(): void {
        this.viewerPopup.instance.repaint();
        this.getSplitterPanelWidth();
    }

    onHidden(): void {
        this.closeViewer();
    }

    onPdfURL(value): void {
        if (value) {
            this.pdfURL = value;
        } else {
            this.pdfURL = null;
        }
    }

    onPdfLoader(event): void {
        setTimeout(() => {
            this.pdfLoader = event;
        }, 250);
    }

    onSplitterDragStart(): void {
        this.pdfLoader = true;
    }

    dragEndPdfLeft(event): void {
        this.pdfLoader = false;
        const sizes = event.sizes;

        this.pdfViewerWidth = sizes[this.pdfOrder - 1];
        this.formPanelWidth = sizes[this.invoiceOrder - 1];

        this.setSplitterPanelWidth();
    }

    onSplitterPositionChange(pdfToLeft): void {
        setTimeout(() => {
            this.pdfViewerToLeft = pdfToLeft;
            if (this.pdfViewerToLeft) {
                this.pdfOrder = 1;
                this.invoiceOrder = 2;
            } else {
                this.pdfOrder = 2;
                this.invoiceOrder = 1;
            }
            this.setSplitterContentPosition();
        }, 100);
    }

    onHideSplitter(separateWindow): void {
        setTimeout(() => {
            this.separateWindow = separateWindow;

            if (this.separateWindow) {
                this.invoiceOrder = 1;
                this.pdfOrder = 0;
            } else {
                if (this.pdfViewerToLeft) {
                    this.pdfOrder = 1;
                    this.invoiceOrder = 2;
                } else {
                    this.pdfOrder = 2;
                    this.invoiceOrder = 1;
                }
            }
        }, 100);
    }

    onTitleChange(title: string): void {
        this.popupTitle = title;
    }

    onReclassifyClose(forceRefresh: boolean): void {
        this.forceRefresh = forceRefresh;
        this.closeViewer();
    }

    onViewerClose(): void {
        this.closeViewer();
    }

    onReclassifyWorkflow(workFlowDetail: WorkflowDetailsResultDto): void {
        this.apBillDetailParam = new APBillParameterDto();
        this.apBillDetailParam.billId = workFlowDetail.apBillId;
        this.apBillDetailParam.communityId = workFlowDetail.communityId;
        this.apBillDetailParam.managementCompanyId = workFlowDetail.managementCompanyId;
        setTimeout(() => {
            this.viewOnly = false;
        }, 200);
    }

    private getSplitterPanelWidth(): void {
        this.formPanelWidth =
            this.localStorageService.getItem(
                StorageKeyConstants.wfEditorFormPanelWidthInPercent,
                CCLocalStorageCategory.WFE
            ) || Constants.splitterFormWidth;
        this.pdfViewerWidth =
            this.localStorageService.getItem(
                StorageKeyConstants.wfInvoicePanelWidthInPercent,
                CCLocalStorageCategory.WFE
            ) || Constants.splitterPDFViewerWidth;

        this.setSplitterPanelWidth();
    }

    private setSplitterPanelWidth(): void {
        this.localStorageService.setItem(
            StorageKeyConstants.wfEditorFormPanelWidthInPercent,
            this.formPanelWidth,
            CCLocalStorageCategory.WFE
        );
        this.localStorageService.setItem(
            StorageKeyConstants.wfInvoicePanelWidthInPercent,
            this.pdfViewerWidth,
            CCLocalStorageCategory.WFE
        );
    }

    private setSplitterContentPosition(): void {
        this.localStorageService.setItem(
            StorageKeyConstants.wfInvoiceViewerPosition,
            this.pdfViewerToLeft.toString(),
            CCLocalStorageCategory.WFE
        );
    }

    private closeViewer(): void {
        this.visible = false;
        this.onClose.emit(this.forceRefresh);
    }
}
